import React from 'react';
import ProtectedRoute from './protected';
import OvertimePage from '../pages/overtime';

export const OvertimeRoutes = [
  <ProtectedRoute exact path='/overtimes' component={OvertimePage} />,
];